module.exports = __webpack_public_path__ + "static/media/logo.b826d1b0.png";